import { Route, Routes, useLocation } from 'react-router';

import '../initDayjs';

import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useBlogPageViewTracking } from './blogHooks/useBlogAnalytics';
import blogHistoryStore from './blogStores/blogHistoryStore';
import BlogLayout from './blogViews/BlogLayout';
import BlogPostDetailPage from './blogViews/detail/BlogPostDetailPage';
import BlogHomePage from './blogViews/home/BlogHomePage';
import BlogPostListPage from './blogViews/list/BlogPostListPage';
import BlogTermsPage from './blogViews/terms/BlogTermsPage';

const App = observer(() => {
    const location = useLocation();

    useEffect(() => {
        blogHistoryStore.push(location);
    }, [location.pathname]);

    useBlogPageViewTracking();

    return (
        // @see React Router: https://reactrouter.com/start/library/routing
        <>
            <Routes>
                <Route element={<BlogLayout />}>
                    <Route index element={<BlogHomePage />} />
                    <Route path="/:lang" element={<BlogHomePage />} />
                    <Route path="/:lang/post/:category/:slug" element={<BlogPostDetailPage />} />
                    <Route path="/:lang/post/:category" element={<BlogPostListPage />} />
                    <Route path="/:lang/terms" element={<BlogTermsPage type="terms" />} />
                    <Route path="/:lang/privacy" element={<BlogTermsPage type="privacy" />} />
                </Route>
            </Routes>
        </>
    );
});

export default App;
